import { GlobalColorCodes, IdValue, LoanItemStatus, LoanItemStatusIconType } from '../../shared/models';

export enum DesktopUnderwritingSystemTypes {
  Dual_DU_LPA = 0,
  DU = 1,
  LPA = 2,
  EA = 3,
}

export enum FhaAusType {
  NotAssigned = 0,
  DU = 1,
  LPA = 2,
}

export const DesktopUnderwritingSystemTypesList: IdValue<DesktopUnderwritingSystemTypes, string>[] = [
  {
    id: DesktopUnderwritingSystemTypes.Dual_DU_LPA,
    value: 'Dual DU & LPA',
    name: 'Dual DU & LPA',
  },
  {
    id: DesktopUnderwritingSystemTypes.DU,
    value: 'DU',
    name: 'Only DU',
  },
  {
    id: DesktopUnderwritingSystemTypes.LPA,
    value: 'LPA',
    name: 'Only LPA',
  },
];

export const DUEarlyAssessmentSystemType: IdValue<DesktopUnderwritingSystemTypes, string> = {
  id: DesktopUnderwritingSystemTypes.EA,
  value: 'DU EA',
  name: 'DU Early Assessment',
};

export const FannieMaeARMPlanNumbers = [
  {
    id: 1000086,
    value: 'Not a Fannie Mae ARM',
    name: 'Not a Fannie Mae ARM',
    plan: '0',
  },
  {
    id: 1000087,
    value: '57- 1 YR TREASURY,CONVERTIBLE  2&6 Caps',
    name: '57- 1 YR TREASURY,CONVERTIBLE  2&6 Caps',
    plan: '57',
  },
  {
    id: 1000088,
    value: '251- FHA ARM: 1 YR TREASURY  1&5 Caps',
    name: '251- FHA ARM: 1 YR TREASURY  1&5 Caps',
    plan: '251',
  },
  {
    id: 1000089,
    value: '346- 6 MO TREASURY  1&5 Caps',
    name: '346- 6 MO TREASURY  1&5 Caps',
    plan: '346',
  },
  {
    id: 1000090,
    value: '383- 1 YR TREASURY   1&4 Caps',
    name: '383- 1 YR TREASURY   1&4 Caps',
    plan: '383',
  },
  {
    id: 1000091,
    value: '421- 1 YR TREASURY   2&4 Caps',
    name: '421- 1 YR TREASURY   2&4 Caps',
    plan: '421',
  },
  {
    id: 1000092,
    value: '510- 1 YR TREASURY   1&5 Caps',
    name: '510- 1 YR TREASURY   1&5 Caps',
    plan: '510',
  },
  {
    id: 1000093,
    value: '511- 1 YR TREASURY,CONVERTIBLE  1&5 Caps',
    name: '511- 1 YR TREASURY,CONVERTIBLE  1&5 Caps',
    plan: '511',
  },
  {
    id: 1000094,
    value: '520- 1 YR TREASURY   2&5 Caps',
    name: '520- 1 YR TREASURY   2&5 Caps',
    plan: '520',
  },
  {
    id: 1000095,
    value: '521- 1 YR TREASURY,CONVERTIBLE  2&5 Caps',
    name: '521- 1 YR TREASURY,CONVERTIBLE  2&5 Caps',
    plan: '521',
  },
  {
    id: 1000096,
    value: '649- 3/3YR TREASURY   2&6 Caps',
    name: '649- 3/3YR TREASURY   2&6 Caps',
    plan: '649',
  },
  {
    id: 1000097,
    value: '650- 3/3YR TREASURY,CONVERTIBLE   2&6 Caps',
    name: '650- 3/3YR TREASURY,CONVERTIBLE   2&6 Caps',
    plan: '650',
  },
  {
    id: 1000098,
    value: '651- 3/1YR TREASURY  2&6 Caps',
    name: '651- 3/1YR TREASURY  2&6 Caps',
    plan: '651',
  },
  {
    id: 1000099,
    value: '652- 3/1 YR TREASURY,CONVERTIBLE  2&6 Caps',
    name: '652- 3/1 YR TREASURY,CONVERTIBLE  2&6 Caps',
    plan: '652',
  },
  {
    id: 1000100,
    value: '660- 5/1 YR TREASURY  2&5 Caps',
    name: '660- 5/1 YR TREASURY  2&5 Caps',
    plan: '660',
  },
  {
    id: 1000101,
    value: '661- 5/1 YR TREASURY,CONVERTIBLE  2&5 Caps',
    name: '661- 5/1 YR TREASURY,CONVERTIBLE  2&5 Caps',
    plan: '661',
  },
  {
    id: 1000102,
    value: '681- 1 YR COST OF FUNDS  2&5 Caps',
    name: '681- 1 YR COST OF FUNDS  2&5 Caps',
    plan: '681',
  },
  {
    id: 1000103,
    value: '682- 1 YR COST OF FUNDS,CONVERTIBLE  2&5 Caps',
    name: '682- 1 YR COST OF FUNDS,CONVERTIBLE  2&5 Caps',
    plan: '682',
  },
  {
    id: 1000104,
    value: '710- 1 YR TREASURY   1&6 Caps',
    name: '710- 1 YR TREASURY   1&6 Caps',
    plan: '710',
  },
  {
    id: 1000105,
    value: '711- 1 YR TREASURY,CONVERTIBLE  1&6 Caps',
    name: '711- 1 YR TREASURY,CONVERTIBLE  1&6 Caps',
    plan: '711',
  },
  {
    id: 1000106,
    value: '714- 1 YR COST OF FUNDS  1.5&5 Caps',
    name: '714- 1 YR COST OF FUNDS  1.5&5 Caps',
    plan: '714',
  },
  {
    id: 1000107,
    value: '720- 1 YR TREASURY   2&6 Caps',
    name: '720- 1 YR TREASURY   2&6 Caps',
    plan: '720',
  },
  {
    id: 1000108,
    value: '721- 1 YR TREASURY,CONVERTIBLE  2&6 Caps',
    name: '721- 1 YR TREASURY,CONVERTIBLE  2&6 Caps',
    plan: '721',
  },
  {
    id: 1000109,
    value: '722- 1 YR COST OF FUNDS  1&5 Caps',
    name: '722- 1 YR COST OF FUNDS  1&5 Caps',
    plan: '722',
  },
  {
    id: 1000110,
    value: '746- 6 MO TREASURY  1&6 Caps',
    name: '746- 6 MO TREASURY  1&6 Caps',
    plan: '746',
  },
  {
    id: 1000111,
    value: '750- 7/1YR TREASURY  2&5 Caps',
    name: '750- 7/1YR TREASURY  2&5 Caps',
    plan: '750',
  },
  {
    id: 1000112,
    value: '751- 7/1YR TREASURY,CONVERTIBLE  2&5 Caps',
    name: '751- 7/1YR TREASURY,CONVERTIBLE  2&5 Caps',
    plan: '751',
  },
  {
    id: 1000113,
    value: '760- 6 MO COST OF FUNDS   1&5 Caps',
    name: '760- 6 MO COST OF FUNDS   1&5 Caps',
    plan: '760',
  },
  {
    id: 1000114,
    value: '761- 6 MO COST OF FUNDS,CONVERTIBLE  1&5 Caps',
    name: '761- 6 MO COST OF FUNDS,CONVERTIBLE  1&5 Caps',
    plan: '761',
  },
  {
    id: 1000115,
    value: '776- 1 YR TREASURY,CONVERTIBLE  1&4 Caps',
    name: '776- 1 YR TREASURY,CONVERTIBLE  1&4 Caps',
    plan: '776',
  },
  {
    id: 1000116,
    value: '791- 1 YR TREASURY,CONVERTIBLE  2&4 Caps',
    name: '791- 1 YR TREASURY,CONVERTIBLE  2&4 Caps',
    plan: '791',
  },
  {
    id: 1000117,
    value: '841- 1 YR TREASURY,CONVERTIBLE  1&4 Caps',
    name: '841- 1 YR TREASURY,CONVERTIBLE  1&4 Caps',
    plan: '841',
  },
  {
    id: 1000118,
    value: '851- 1 YR TREASURY,CONVERTIBLE  1&5 Caps',
    name: '851- 1 YR TREASURY,CONVERTIBLE  1&5 Caps',
    plan: '851',
  },
  {
    id: 1000119,
    value: '861- 1 YR TREASURY,CONVERTIBLE  1&6 Caps',
    name: '861- 1 YR TREASURY,CONVERTIBLE  1&6 Caps',
    plan: '861',
  },
  {
    id: 1000120,
    value: '975- 7 YR TWO-STEP',
    name: '975- 7 YR TWO-STEP',
    plan: '975',
  },
  {
    id: 1000121,
    value: '1029- 5 YR TWO-STEP',
    name: '1029- 5 YR TWO-STEP',
    plan: '1029',
  },
  {
    id: 1000122,
    value: '1030- 6 MO CERTIFICATE OF DEPOSIT,CONVERTIBLE  1&6 Caps',
    name: '1030- 6 MO CERTIFICATE OF DEPOSIT,CONVERTIBLE  1&6 Caps',
    plan: '1030',
  },
  {
    id: 1000123,
    value: '1031- 6 MO CERTIFICATE OF DEPOSIT  1&6 Caps',
    name: '1031- 6 MO CERTIFICATE OF DEPOSIT  1&6 Caps',
    plan: '1031',
  },
  {
    id: 1000124,
    value: '1423- 10/1 YR TREASURY  2&5 Caps',
    name: '1423- 10/1 YR TREASURY  2&5 Caps',
    plan: '1423',
  },
  {
    id: 1000125,
    value: '1437- 10/1 YR TREASURY,CONVERTIBLE  2&5 Caps',
    name: '1437- 10/1 YR TREASURY,CONVERTIBLE  2&5 Caps',
    plan: '1437',
  },
  {
    id: 1000126,
    value: '1443- 6 MO WSJ LIBOR  1&5 Caps',
    name: '1443- 6 MO WSJ LIBOR  1&5 Caps',
    plan: '1443',
  },
  {
    id: 1000127,
    value: '1444- 6 MO WSJ LIBOR,CONVERTIBLE   1&5 Caps',
    name: '1444- 6 MO WSJ LIBOR,CONVERTIBLE   1&5 Caps',
    plan: '1444',
  },
  {
    id: 1000128,
    value: '1445- 6 MO WSJ LIBOR  1&6 Caps',
    name: '1445- 6 MO WSJ LIBOR  1&6 Caps',
    plan: '1445',
  },
  {
    id: 1000129,
    value: '1446- 6 MO WSJ LIBOR,CONVERTIBLE   1&6 Caps',
    name: '1446- 6 MO WSJ LIBOR,CONVERTIBLE   1&6 Caps',
    plan: '1446',
  },
  {
    id: 1000130,
    value: '2236  3/1 TREASURY, 2/2/6 caps, 40 year term',
    name: '2236  3/1 TREASURY, 2/2/6 caps, 40 year term',
    plan: '2236',
  },
  {
    id: 1000131,
    value: '2238  5/1 TREASURY, 2/2/6 caps, 40 year term',
    name: '2238  5/1 TREASURY, 2/2/6 caps, 40 year term',
    plan: '2238',
  },
  {
    id: 1000132,
    value: '2699  5/1 TREASURY, 5/2/5 caps, 40 year term',
    name: '2699  5/1 TREASURY, 5/2/5 caps, 40 year term',
    plan: '2699',
  },
  {
    id: 1000133,
    value: '2703  10/1 TREASURY, 5/2/5 caps, 40 year term',
    name: '2703  10/1 TREASURY, 5/2/5 caps, 40 year term',
    plan: '2703',
  },
  {
    id: 1000134,
    value: '2704  7/1 TREASURY, 5/2/5 caps, 40 year term',
    name: '2704  7/1 TREASURY, 5/2/5 caps, 40 year term',
    plan: '2704',
  },
  {
    id: 1000135,
    value: '3128  5/1 LIBOR, 5/2/5 caps, 40 year term',
    name: '3128  5/1 LIBOR, 5/2/5 caps, 40 year term',
    plan: '3128',
  },
  {
    id: 1000136,
    value: '3130  3/1 LIBOR, 2/2/6 caps, 40 year term',
    name: '3130  3/1 LIBOR, 2/2/6 caps, 40 year term',
    plan: '3130',
  },
  {
    id: 1000137,
    value: '3223- 5/1 - 2/2/5 Caps 5 years int only - LIBOR',
    name: '3223- 5/1 - 2/2/5 Caps 5 years int only - LIBOR',
    plan: '3223',
  },
  {
    id: 1000138,
    value: '3224- 7/1 - 5/2/5 Caps 7 years int only - LIBOR',
    name: '3224- 7/1 - 5/2/5 Caps 7 years int only - LIBOR',
    plan: '3224',
  },
  {
    id: 1000139,
    value: '3225- 10/1 - 5/2/5 Caps 10 years int only - LIBOR',
    name: '3225- 10/1 - 5/2/5 Caps 10 years int only - LIBOR',
    plan: '3225',
  },
  {
    id: 1000140,
    value: '3226- 5/1 - 2/2/5 Caps 5 years int only - CMT',
    name: '3226- 5/1 - 2/2/5 Caps 5 years int only - CMT',
    plan: '3226',
  },
  {
    id: 1000141,
    value: '3227- 7/1 - 5/2/5 Caps 7 years int only - CMT',
    name: '3227- 7/1 - 5/2/5 Caps 7 years int only - CMT',
    plan: '3227',
  },
  {
    id: 1000142,
    value: '3228- 10/1 - 5/2/5 Caps 10 years int only - CMT',
    name: '3228- 10/1 - 5/2/5 Caps 10 years int only - CMT',
    plan: '3228',
  },
  {
    id: 1000143,
    value: '3252 - 5/1 LIBOR ARM, 5, 2 & 5 Caps',
    name: '3252 - 5/1 LIBOR ARM, 5, 2 & 5 Caps',
    plan: '3252',
  },
  {
    id: 1000144,
    value: '3270- 3/1 - 2/2/6 Caps 3 years int only - LIBOR',
    name: '3270- 3/1 - 2/2/6 Caps 3 years int only - LIBOR',
    plan: '3270',
  },
  {
    id: 1000145,
    value: '3271- 3/1 - 2/2/6 Caps 3 years int only - CMT',
    name: '3271- 3/1 - 2/2/6 Caps 3 years int only - CMT',
    plan: '3271',
  },
  {
    id: 1000146,
    value: '3502- 5/1 ARM - 5/2/5 Caps 5 years int only - LIBOR',
    name: '3502- 5/1 ARM - 5/2/5 Caps 5 years int only - LIBOR',
    plan: '3502',
  },
  {
    id: 1000147,
    value: '3503- 5/1 ARM - 5/2/5 Caps 5 years int only - CMT',
    name: '3503- 5/1 ARM - 5/2/5 Caps 5 years int only - CMT',
    plan: '3503',
  },
  {
    id: 1000148,
    value: '3504- 5/1 ARM - 5/2/5 Caps 10 years int only - CMT',
    name: '3504- 5/1 ARM - 5/2/5 Caps 10 years int only - CMT',
    plan: '3504',
  },
  {
    id: 1000149,
    value: '3505- 5/1 ARM - 5/2/5 Caps 10 years int only - LIBOR',
    name: '3505- 5/1 ARM - 5/2/5 Caps 10 years int only - LIBOR',
    plan: '3505',
  },
  {
    id: 1000150,
    value: '3513- 3/1 ARM - 2/2/6 Caps 10 years int only - CMT',
    name: '3513- 3/1 ARM - 2/2/6 Caps 10 years int only - CMT',
    plan: '3513',
  },
  {
    id: 1000151,
    value: '3514- 3/1 ARM - 2/2/6 Caps 10 years int only - LIBOR',
    name: '3514- 3/1 ARM - 2/2/6 Caps 10 years int only - LIBOR',
    plan: '3514',
  },
  {
    id: 1000152,
    value: '3515- 5/1 ARM - 2/2/5 Caps 10 years int only - CMT',
    name: '3515- 5/1 ARM - 2/2/5 Caps 10 years int only - CMT',
    plan: '3515',
  },
  {
    id: 1000153,
    value: '3516- 5/1 ARM - 2/2/5 Caps 10 years int only - LIBOR',
    name: '3516- 5/1 ARM - 2/2/5 Caps 10 years int only - LIBOR',
    plan: '3516',
  },
  {
    id: 1000154,
    value: '3517- 7/1 ARM - 5/2/5 Caps 10 years int only - CMT',
    name: '3517- 7/1 ARM - 5/2/5 Caps 10 years int only - CMT',
    plan: '3517',
  },
  {
    id: 1000155,
    value: '3518- 7/1 ARM - 5/2/5 Caps 10 years int only - LIBOR',
    name: '3518- 7/1 ARM - 5/2/5 Caps 10 years int only - LIBOR',
    plan: '3518',
  },
  {
    id: 1000156,
    value: '3557  5/1 LIBOR, 2/2/6 caps, 40 year term',
    name: '3557  5/1 LIBOR, 2/2/6 caps, 40 year term',
    plan: '3557',
  },
  {
    id: 1000157,
    value: '3558  7/1 LIBOR, 5/2/5 caps, 40 year term',
    name: '3558  7/1 LIBOR, 5/2/5 caps, 40 year term',
    plan: '3558',
  },
  {
    id: 1000158,
    value: '3559  10/1 LIBOR, 5/2/5 caps, 40 year term',
    name: '3559  10/1 LIBOR, 5/2/5 caps, 40 year term',
    plan: '3559',
  },
  {
    id: 1000159,
    value: 'LENDER ARM PLAN',
    name: 'LENDER ARM PLAN',
    plan: '!FNMA',
  },
  {
    id: 1000160,
    value: 'FHA Hybrid ARM',
    name: 'FHA Hybrid ARM',
    plan: 'FHAHY',
  },
  {
    id: 1000161,
    value: 'FM GENERIC, 6 MONTH',
    name: 'FM GENERIC, 6 MONTH',
    plan: 'GEN06',
  },
  {
    id: 1000162,
    value: 'FM GENERIC, 10 YR',
    name: 'FM GENERIC, 10 YR',
    plan: 'GEN10',
  },
  {
    id: 1000163,
    value: 'FM GENERIC, 1 YR, 1% ANNUAL Cap',
    name: 'FM GENERIC, 1 YR, 1% ANNUAL Cap',
    plan: 'GEN1A',
  },
  {
    id: 1000164,
    value: 'FM GENERIC, 1 YR, 2% ANNUAL Cap',
    name: 'FM GENERIC, 1 YR, 2% ANNUAL Cap',
    plan: 'GEN1B',
  },
  {
    id: 1000165,
    value: 'FM GENERIC, 3 YR',
    name: 'FM GENERIC, 3 YR',
    plan: 'GEN3',
  },
  {
    id: 1000166,
    value: 'FM GENERIC, 5 YR',
    name: 'FM GENERIC, 5 YR',
    plan: 'GEN5',
  },
  {
    id: 1000167,
    value: 'FM GENERIC, 7 YR',
    name: 'FM GENERIC, 7 YR',
    plan: 'GEN7',
  },
  {
    id: 1000168,
    value: 'FM GENERIC, NEGATIVE AMORTIZATION',
    name: 'FM GENERIC, NEGATIVE AMORTIZATION',
    plan: 'NGAM',
  },
  {
    id: 1000169,
    value: 'VA 1 YR ARM',
    name: 'VA 1 YR ARM',
    plan: 'VA1YR',
  },
  {
    id: 1000170,
    value: 'VA Hybrid ARM',
    name: 'VA Hybrid ARM',
    plan: 'VAARM',
  },
  {
    id: 1000171,
    value: '3/1 LIBOR ARM',
    name: '3/1 LIBOR ARM',
    plan: '2723',
  },
  {
    id: 1000172,
    value: '5/1 LIBOR ARM',
    name: '5/1 LIBOR ARM',
    plan: '2737',
  },
  {
    id: 1000173,
    value: '7/1 LIBOR ARM',
    name: '7/1 LIBOR ARM',
    plan: '2727',
  },
  {
    id: 1000174,
    value: '10/1 LIBOR ARM',
    name: '10/1 LIBOR ARM',
    plan: '2729',
  },
  {
    id: 1000175,
    value: '2725- 5/1 ARM 2/2/5 Life Caps 1 year LIBOR',
    name: '2725- 5/1 ARM 2/2/5 Life Caps 1 year LIBOR',
    plan: '2725',
  },
  {
    id: 1000176,
    value: '4926 - 3/6mo SOFR, 2/1/5 Caps',
    name: '4926 - 3/6mo SOFR, 2/1/5 Caps',
    plan: '4926',
  },
  {
    id: 1000177,
    value: '4927 - 5/6mo SOFR, 2/1/5 Caps',
    name: '4927 - 5/6mo SOFR, 2/1/5 Caps',
    plan: '4927',
  },
  {
    id: 1000178,
    value: '4928 - 7/6mo SOFR, 5/1/5 Caps',
    name: '4928 - 7/6mo SOFR, 5/1/5 Caps',
    plan: '4928',
  },
  {
    id: 1000179,
    value: '4929 - 10/6mo SOFR, 5/1/5 Caps',
    name: '4929 - 10/6mo SOFR, 5/1/5 Caps',
    plan: '4929',
  },
];

export enum ExistingMortgageTypes {
  Fannie_Mae = 1,
  Freddie_Mac = 2,
  Seller_Or_Other = 3,
  Unknown = 4,
}

export const ExistingMortgageTypesList: IdValue<ExistingMortgageTypes, string>[] = [
  {
    id: ExistingMortgageTypes.Fannie_Mae,
    value: 'Fannie Mae',
    name: 'Fannie Mae',
  },
  {
    id: ExistingMortgageTypes.Freddie_Mac,
    value: 'Freddie Mac',
    name: 'Freddie Mac',
  },
  {
    id: ExistingMortgageTypes.Seller_Or_Other,
    value: 'Sellor Or Other',
    name: 'Sellor Or Other',
  },
  {
    id: ExistingMortgageTypes.Unknown,
    value: 'Unknown',
    name: 'Unknown',
  },
];

export const offeringIdentifierList: IdValue[] = [
  {
    id: 0,
    value: 'Select',
    name: 'Select',
  },
  {
    id: 210,
    value: 'Alt 97',
    name: 'Alt 97',
  },
  {
    id: 241,
    value: 'Home Possible',
    name: 'Home Possible',
  },
  {
    id: 243,
    value: 'Home possible NH solution 97',
    name: 'Home possible NH solution 97',
  },
  {
    id: 244,
    value: 'Home Possible 3% Cash',
    name: 'Home Possible 3% Cash',
  },
  {
    id: 245,
    value: 'Home Possible Neighbourhood Solution 3% Cash',
    name: 'Home Possible Neighbourhood Solution 3% Cash',
  },
  {
    id: 250,
    value: 'Home Possible Advantage',
    name: 'Home Possible Advantage',
  },
  {
    id: 251,
    value: 'Home Possible Advantage for HFAs',
    name: 'Home Possible Advantage for HFAs',
  },
  {
    id: 310,
    value: 'Relief Refinance - Open Access',
    name: 'Relief Refinance - Open Access',
  },
  {
    id: 904,
    value: 'Refi Possible',
    name: 'Refi Possible',
  },
  {
    id: 1000,
    value: 'Other',
    name: 'Other',
  },
];

export enum DownpaymentSourceTypes {
  Select = 0,
  Checking_Or_Savings = 1,
  Deposit_On_Sales_Contract = 2,
  Equity_on_Sold_Property = 3,
  Equity_on_Pending_Sale = 4,
  Equity_on_Subject_Property = 5,
  Gift_Funds = 6,
  Stocks_and_Bonds = 7,
  Lot_Equity = 8,
  Bridge_Loan = 9,
  Unsecured_Borrowed_Funds = 10,
  Trust_Funds = 11,
  Retirement_Funds = 12,
  Rent_with_Option_to_Purchase = 13,
  Life_Insurance_Cash_Value = 14,
  Sale_of_Chattel = 15,
  Trade_Equity = 16,
  Sweat_Equity = 17,
  Cash_on_Hand = 18,
  Secured_Borrowed_Funds = 20,
  FHA_Gift_NA = 21,
  FHA_Gift_Relative = 22,
  FHA_Gift_Gov_Assist = 23,
  FHA_Gift_Employer = 24,
  FHA_Gift_Non_Profit_Seller_Funded = 25,
  FHA_Gift_Non_Profit_Non_Seller_Funded = 26,
  FHA_Gift_Federal_Agency = 27,
  FHA_Gift_State_Agency = 28,
  FHA_Gift_Local_Agency = 29,
  FHA_Gift_Other = 30,
  FHA_Gift_Community_Non_Profit = 31,
  FHA_Gift_Religious_Non_Profit = 32,
  Grant = 33,
  FHA_Grant_Relative = 34,
  FHA_Grant_Federal_Agency = 35,
  FHA_Grant_State_Agency = 36,
  FHA_Grant_Local_Agency = 37,
  FHA_Grant_Employer = 38,
  FHA_Grant_Other = 39,
  FHA_Grant_Community_Non_Profit = 40,
  FHA_Grant_Religious_Non_Profit = 41,
  FHA_Gift_Borrower = 42,
  FHA_Gift_Property_Seller = 43,
  FHA_Gift_Unmarried_Partner = 44,
  FHA_Grant_Borrower = 45,
  FHA_Grant_Property_Seller = 46,
  FHA_Grant_Unmarried_Partner = 47,
}

export const DownpaymentSourceTypesList: IdValue<DownpaymentSourceTypes, string>[] = [
  {
    id: DownpaymentSourceTypes.Select,
    value: 'Select',
    name: 'Select',
  },
  {
    id: DownpaymentSourceTypes.Checking_Or_Savings,
    value: 'Checking or Savings',
    name: 'Checking or Savings',
  },
  {
    id: DownpaymentSourceTypes.Deposit_On_Sales_Contract,
    value: 'Deposit On Sales Contract',
    name: 'Deposit On Sales Contract',
  },
  {
    id: DownpaymentSourceTypes.Equity_on_Sold_Property,
    value: 'Equity on Sold Property',
    name: 'Equity on Sold Property',
  },
  {
    id: DownpaymentSourceTypes.Equity_on_Pending_Sale,
    value: 'Equity on Pending Sale',
    name: 'Equity on Pending Sale',
  },
  {
    id: DownpaymentSourceTypes.Equity_on_Subject_Property,
    value: 'Equity on Subject Property',
    name: 'Equity on Subject Property',
  },
  {
    id: DownpaymentSourceTypes.Gift_Funds,
    value: 'Gift Funds',
    name: 'Gift Funds',
  },
  {
    id: DownpaymentSourceTypes.Stocks_and_Bonds,
    value: 'Stocks and Bonds',
    name: 'Stocks and Bonds',
  },
  {
    id: DownpaymentSourceTypes.Lot_Equity,
    value: 'Lot Equity',
    name: 'Lot Equity',
  },
  {
    id: DownpaymentSourceTypes.Retirement_Funds,
    value: 'Retirement Funds',
    name: 'Retirement Funds',
  },
  {
    id: DownpaymentSourceTypes.Rent_with_Option_to_Purchase,
    value: 'Rent with Option to Purchase',
    name: 'Rent with Option to Purchase',
  },
  {
    id: DownpaymentSourceTypes.Life_Insurance_Cash_Value,
    value: 'Life Insurance Cash Value',
    name: 'Life Insurance Cash Value',
  },
  {
    id: DownpaymentSourceTypes.Sale_of_Chattel,
    value: 'Sale of Chattel',
    name: 'Sale of Chattel',
  },
  {
    id: DownpaymentSourceTypes.Trade_Equity,
    value: 'Trade Equity',
    name: 'Trade Equity',
  },
  {
    id: DownpaymentSourceTypes.Sweat_Equity,
    value: 'Sweat Equity',
    name: 'Sweat Equity',
  },
  {
    id: DownpaymentSourceTypes.Cash_on_Hand,
    value: 'Cash on Hand',
    name: 'Cash on Hand',
  },
  {
    id: DownpaymentSourceTypes.Secured_Borrowed_Funds,
    value: 'Secured Borrowed Funds',
    name: 'Secured Borrowed Funds',
  },
  {
    id: DownpaymentSourceTypes.FHA_Gift_NA,
    value: 'FHA Gift NA',
    name: 'FHA Gift NA',
  },
  {
    id: DownpaymentSourceTypes.FHA_Gift_Relative,
    value: 'FHA Gift Relative',
    name: 'FHA Gift Relative',
  },
  {
    id: DownpaymentSourceTypes.FHA_Gift_Gov_Assist,
    value: 'FHA Gift Gov Assist',
    name: 'FHA Gift Gov Assist',
  },
  {
    id: DownpaymentSourceTypes.FHA_Gift_Employer,
    value: 'FHA Gift Employer',
    name: 'FHA Gift Employer',
  },
  {
    id: DownpaymentSourceTypes.FHA_Gift_Non_Profit_Seller_Funded,
    value: 'FHA Gift Non Profit Seller Funded',
    name: 'FHA Gift Non Profit Seller Funded',
  },
  {
    id: DownpaymentSourceTypes.FHA_Gift_Non_Profit_Non_Seller_Funded,
    value: 'FHA Gift Non Profit Non Seller Funded',
    name: 'FHA Gift Non Profit Non Seller Funded',
  },
  {
    id: DownpaymentSourceTypes.FHA_Gift_Federal_Agency,
    value: 'FHA Gift Federal Agency',
    name: 'FHA Gift Federal Agency',
  },
  {
    id: DownpaymentSourceTypes.FHA_Gift_State_Agency,
    value: 'FHA Gift State Agency',
    name: 'FHA Gift State Agency',
  },
  {
    id: DownpaymentSourceTypes.FHA_Gift_Local_Agency,
    value: 'FHA Gift Local Agency',
    name: 'FHA Gift Local Agency',
  },
  {
    id: DownpaymentSourceTypes.FHA_Gift_Other,
    value: 'FHA Gift Other',
    name: 'FHA Gift Other',
  },
  {
    id: DownpaymentSourceTypes.FHA_Gift_Community_Non_Profit,
    value: 'FHA Gift Community Non Profit',
    name: 'FHA Gift Community Non Profit',
  },
  {
    id: DownpaymentSourceTypes.FHA_Gift_Religious_Non_Profit,
    value: 'FHA Gift Religious Non Profit',
    name: 'FHA Gift Religious Non Profit',
  },
  {
    id: DownpaymentSourceTypes.Grant,
    value: 'Grant',
    name: 'Grant',
  },
  {
    id: DownpaymentSourceTypes.FHA_Grant_Relative,
    value: 'FHA Grant Relative',
    name: 'FHA Grant Relative',
  },
  {
    id: DownpaymentSourceTypes.FHA_Grant_Federal_Agency,
    value: 'FHA Grant Federal Agency',
    name: 'FHA Grant Federal Agency',
  },
  {
    id: DownpaymentSourceTypes.FHA_Grant_State_Agency,
    value: 'FHA Grant State Agency',
    name: 'FHA Grant State Agency',
  },
  {
    id: DownpaymentSourceTypes.FHA_Grant_Local_Agency,
    value: 'FHA Grant Local Agency',
    name: 'FHA Grant Local Agency',
  },
  {
    id: DownpaymentSourceTypes.FHA_Grant_Employer,
    value: 'FHA Grant Relative',
    name: 'FHA Grant Relative',
  },
  {
    id: DownpaymentSourceTypes.FHA_Grant_Other,
    value: 'FHA Grant Other',
    name: 'FHA Grant Other',
  },
  {
    id: DownpaymentSourceTypes.FHA_Grant_Community_Non_Profit,
    value: 'FHA Grant Community Non Profit',
    name: 'FHA Grant Community Non Profit',
  },
  {
    id: DownpaymentSourceTypes.FHA_Grant_Religious_Non_Profit,
    value: 'FHA Grant Religious Non Profit',
    name: 'FHA Grant Religious Non Profit',
  },
  {
    id: DownpaymentSourceTypes.FHA_Gift_Borrower,
    value: 'FHA Gift Borrower',
    name: 'FHA Gift Borrower',
  },
  {
    id: DownpaymentSourceTypes.FHA_Gift_Property_Seller,
    value: 'FHA Gift Property Seller',
    name: 'FHA Gift Property Seller',
  },
  {
    id: DownpaymentSourceTypes.FHA_Gift_Unmarried_Partner,
    value: 'FHA Gift Unmarried Partner',
    name: 'FHA Gift Unmarried Partner',
  },
  {
    id: DownpaymentSourceTypes.FHA_Grant_Borrower,
    value: 'FHA Grant Borrower',
    name: 'FHA Grant Borrower',
  },
  {
    id: DownpaymentSourceTypes.FHA_Grant_Property_Seller,
    value: 'FHA Grant Property Seller',
    name: 'FHA Grant Property Seller',
  },
  {
    id: DownpaymentSourceTypes.FHA_Grant_Unmarried_Partner,
    value: 'FHA Grant Unmarried Partner',
    name: 'FHA Grant Unmarried Partner',
  },
];

export enum CommunitySecondsTypes {
  NotAssigned = 0,
  AnyPaymentRequiredWithinFirstFiveYears = 1,
  PaymentsDeferredFiveOrMoreYearsFullyForgiven = 2,
  PaymentsDeferredFiveOrMoreYearsNotFullyForgiven = 3,
}

export const CommunitySecondsTypesViewValues: IdValue<any, any, any>[] = [
  new IdValue(CommunitySecondsTypes.NotAssigned, 'Select One', ''),
  new IdValue(CommunitySecondsTypes.AnyPaymentRequiredWithinFirstFiveYears, 'Any Payment Required Within First Five Years', ''),
  new IdValue(CommunitySecondsTypes.PaymentsDeferredFiveOrMoreYearsFullyForgiven, 'Payments Deferred Five Or More Years Fully Forgiven', ''),
  new IdValue(CommunitySecondsTypes.PaymentsDeferredFiveOrMoreYearsNotFullyForgiven, 'Payments Deferred Five Or More Years Not Fully Forgiven', ''),
];

export enum BuydownContributorTypes {
  Select = 0,
  Seller = 1,
  Builder = 2,
  Borrower = 3,
  LenderPremiumFinanced = 4,
  Other = 5,
  NonParentRelative = 6,
  UnrelatedFried = 7,
  Employer = 8,
}

export enum BuildingStatusTypes {
  Select = 0,
  Proposed = 1,
  SubstantiallyRehabilitated = 2,
  UnderConstruction = 3,
  Existing = 4,
  AlterationImprovementRepair = 5,
  Complete = 6,
  Other = 7,
}

export enum AusPropertyOwnershipTypes {
  Select = 0,
  Condominium = 1,
  CondominiumHotel = 2,
  Cooperative = 3,
  Timeshare = 4,
  Other = 5,
}

export enum AusNewConstructionTypes {
  Select = 0,
  NewlyBuilt = 1,
  ConstructionConversion = 2,
}

export enum FannieCLProduct {
  Select = 0,
  MyCommunityMortgage = 4,
  HFAAffordableAdvantage = 6,
  HFAPreferred = 7,
  HomeReady = 8,
}

export const FannieCLProductViewValues: IdValue<any, any, any>[] = [
  new IdValue(FannieCLProduct.Select, 'Select One', 'Select One'),
  new IdValue(FannieCLProduct.HFAAffordableAdvantage, 'HFA Preferred Risk Sharing', 'HFA Preferred Risk Sharing'),
  new IdValue(FannieCLProduct.HFAPreferred, 'HFA Preferred', 'HFA Preferred'),
  new IdValue(FannieCLProduct.HomeReady, 'HomeReady', 'HomeReady'),
];

export class VerificationServiceModel {
  borrowerID: number;
  referenceNumber: string;
  serviceOrderId: number;
  vendorType: AusVerificationServicesVendorTypes;
  vendorTypeOtherName: string;
  verificationType: AusVerificationServicesTypes;
  isDeleted = false;
  static createEmptyModel() {
    const vsModel = new VerificationServiceModel();
    vsModel.serviceOrderId = -1;
    vsModel.vendorType = null;
    vsModel.verificationType = null;
    return vsModel;
  }
}

export class AusLoanModel {
  buydownContributor: number;
  energyImprovementAmount: number;
  entitlementAmount: number;
  fannieARMPlanNumber: number;
  fannieRecommendation: string;
  firstMortgageHolder: number;
  freddieCashReserves: number;
  freddieCreditRiskType: string;
  FreddiePurchaseEligibility: string;
  FreddieRecommendation: number;
  offeringIdentifier: number;
  paceLoanPayoffAmount: number;
  refinanceCashOutAmount: number;
  salesConcessions: number;
  sellerProvidedBelowMarketFinancing: boolean;
  totalMortgagedProperties: number;
  fannieCaseFileId?: string;
  freddieLoanKeyNumber?: string;
  originalLoanCtcRequested?: string;
  originationProcessingPoint?: number;
}

export class AusDownpaymentModel {
  downPaymentAmount1: number;
  downPaymentType1: number;
  downPaymentAmount2: number;
  downPaymentType2: number;
}
export class AusPropertyModel {
  newConstruction: number;
  buildingStatus: number;
  propertyOwnership: number;
  aduCount: number;
}

export class CommunityLendingModel {
  isCommunityLendingEnabled: boolean;
  communitySeconds: boolean;
  fannieMaeCommunityLendingProduct: number;
  communitySecondsRepayment: number;
}

export class GovernmentLoanModel {
  borrowerPaidClosingCosts: number;
  vaResidualIncome: number;
  financedFHADiscountPoints: string;
}

export class AusErrorLogModel {
  id: number;
  title: string;
  message: string;
  system: 'DU' | 'LPA' | 'EA';

  static getDuLpaErrorsFromResponse(duResponse: any, lpResponse: any) {
    const duLpaErrors: AusErrorLogModel[] = [];
    let errorIndex = 0;
    if (duResponse) {
      if (duResponse.error) {
        duResponse.error.Errors.Exception.forEach((exceptionMessage) => {
          duLpaErrors.push({
            id: errorIndex++,
            message: exceptionMessage,
            title: '',
            system: 'DU',
          });
        });
      } else {
        (duResponse as any).validationIssues.forEach((issue) => {
          duLpaErrors.push({
            id: errorIndex++,
            message: issue.description,
            title: '',
            system: 'DU',
          });
        });
      }
    }

    if (lpResponse) {
      (lpResponse as any).validationIssues.forEach((issue) => {
        duLpaErrors.push({
          id: errorIndex++,
          message: issue.description,
          title: '',
          system: 'LPA',
        });
      });
    }
    return duLpaErrors;
  }
}

export enum AusResult {
  NotAssigned = 0,
  ApproveEligible = 1,
  ApproveIneligible = 2,
  ReferEligible = 3,
  ReferIneligible = 4,
  ReferWithCaution = 5,
  OutOfScope = 6,
  Error = 7,
  Accept = 8,
  Caution = 9,
  Ineligible = 10,
  Incomplete = 11,
  Invalid = 12,
  Refer = 13,
  Eligible = 14,
  UnableToDetermineOrUnknown = 15,
  Other = 16,
  NotApplicable = 17,
  AcceptEligible = 18,
  AcceptIneligible = 19,
  AcceptUnableToDetermine = 20,
  ReferWithCautionEligible = 21,
  ReferWithCautionIneligible = 22,
  ReferUnableToDetermine = 23,
  ReferWithCautionUnableToDetermine = 24,
}

// Placeholder till we get more values
export enum LpaResult {
  Incomplete = -1,
  AcceptFreddieMacEligible = 0,
  ReferFreddieMacEligible = 1,
  CautionFreddieMacEligible = 2,
  AcceptFreddieMacIneligible = 3,
  ReferFreddieMacIneligible = 4,
  CautionFreddieMacIneligible = 5,
  Accept = 6,
  ReferEligible = 7,
  ApproveEligible = 8,
  ApproveIneligible = 9,
  Error = 10,
  OutofScope = 11,
  ReferwithCaution = 12,
  Refer = 13,
  ReferIneligible = 14,
}

// Placeholder till we get more values
export const LpaResultColorCodes: { [key: string]: string } = {
  [LpaResult.Incomplete]: GlobalColorCodes.severityError,
  [LpaResult.AcceptFreddieMacEligible]: GlobalColorCodes.severityGreen,
  [LpaResult.ReferFreddieMacEligible]: GlobalColorCodes.severityError,
  [LpaResult.CautionFreddieMacEligible]: GlobalColorCodes.severityError,
  [LpaResult.AcceptFreddieMacIneligible]: GlobalColorCodes.severityError,
  [LpaResult.ReferFreddieMacIneligible]: GlobalColorCodes.severityError,
  [LpaResult.CautionFreddieMacIneligible]: GlobalColorCodes.severityError,
  [LpaResult.Accept]: GlobalColorCodes.severityGreen,
  [LpaResult.ReferEligible]: GlobalColorCodes.severityYellow,
  [LpaResult.ApproveEligible]: GlobalColorCodes.severityYellow,
  [LpaResult.ApproveIneligible]: GlobalColorCodes.severityYellow,
  [LpaResult.Error]: GlobalColorCodes.severityYellow,
  [LpaResult.OutofScope]: GlobalColorCodes.severityYellow,
  [LpaResult.ReferwithCaution]: GlobalColorCodes.severityYellow,
  [LpaResult.Refer]: GlobalColorCodes.severityYellow,
  [LpaResult.ReferIneligible]: GlobalColorCodes.severityYellow,
};

// Placeholder till we get more values
export const LpaResultStatusIcon: { [key: string]: string } = {
  [LpaResult.Incomplete]: `${LoanItemStatus.NotComplete} ${LoanItemStatusIconType.EmptyCircle}`,
  [LpaResult.AcceptFreddieMacEligible]: `${LoanItemStatus.Complete} ${LoanItemStatusIconType.Circle}`,
  [LpaResult.ReferFreddieMacEligible]: `${LoanItemStatus.Warning} ${LoanItemStatusIconType.Diamond}`,
  [LpaResult.CautionFreddieMacEligible]: `${LoanItemStatus.Error} ${LoanItemStatusIconType.Square}`,
  [LpaResult.AcceptFreddieMacIneligible]: `${LoanItemStatus.Error} ${LoanItemStatusIconType.Square}`,
  [LpaResult.ReferFreddieMacIneligible]: `${LoanItemStatus.Error} ${LoanItemStatusIconType.Square}`,
  [LpaResult.CautionFreddieMacIneligible]: `${LoanItemStatus.Error} ${LoanItemStatusIconType.Square}`,
  [LpaResult.Accept]: `${LoanItemStatus.Complete} ${LoanItemStatusIconType.Circle}`,
  [LpaResult.ReferEligible]: `${LoanItemStatus.Warning} ${LoanItemStatusIconType.Diamond}`,
  [LpaResult.ApproveEligible]: `${LoanItemStatus.Warning} ${LoanItemStatusIconType.Diamond}`,
  [LpaResult.ApproveIneligible]: `${LoanItemStatus.Warning} ${LoanItemStatusIconType.Diamond}`,
  [LpaResult.Error]: `${LoanItemStatus.Error} ${LoanItemStatusIconType.Square}`,
  [LpaResult.OutofScope]: `${LoanItemStatus.Warning} ${LoanItemStatusIconType.Diamond}`,
  [LpaResult.ReferwithCaution]: `${LoanItemStatus.Warning} ${LoanItemStatusIconType.Diamond}`,
  [LpaResult.Refer]: `${LoanItemStatus.Warning} ${LoanItemStatusIconType.Diamond}`,
  [LpaResult.ReferIneligible]: `${LoanItemStatus.Warning} ${LoanItemStatusIconType.Diamond}`,
};

// TODO: Find the correct colors for each code
export const AusResultColorCodes: { [key: number]: string } = {
  [AusResult.NotAssigned]: GlobalColorCodes.severityYellow,
  [AusResult.ApproveEligible]: GlobalColorCodes.severityGreen,
  [AusResult.ApproveIneligible]: GlobalColorCodes.severityYellow,
  [AusResult.ReferEligible]: GlobalColorCodes.severityYellow,
  [AusResult.ReferIneligible]: GlobalColorCodes.severityError,
  [AusResult.ReferWithCaution]: GlobalColorCodes.severityError,
  [AusResult.OutOfScope]: GlobalColorCodes.severityError,
  [AusResult.Error]: GlobalColorCodes.severityError,
  [AusResult.Eligible]: GlobalColorCodes.severityGreen,
  [AusResult.Accept]: GlobalColorCodes.severityGreen,
  // [AusResult.Eligible]: GlobalColorCodes.severityError, // LPA - Scenario 1
  [AusResult.Ineligible]: GlobalColorCodes.severityError,
  [AusResult.Invalid]: GlobalColorCodes.severityError,
  [AusResult.Caution]: GlobalColorCodes.severityError,
  [AusResult.Incomplete]: GlobalColorCodes.severityError,
  [AusResult.UnableToDetermineOrUnknown]: GlobalColorCodes.severityYellow,
  [AusResult.Other]: GlobalColorCodes.severityYellow,
  [AusResult.NotApplicable]: GlobalColorCodes.severityYellow,
  [AusResult.AcceptEligible]: GlobalColorCodes.severityGreen,
  [AusResult.AcceptIneligible]: GlobalColorCodes.severityGreen,
  [AusResult.AcceptUnableToDetermine]: GlobalColorCodes.severityGreen,
  [AusResult.ReferWithCautionEligible]: GlobalColorCodes.severityYellow,
  [AusResult.ReferWithCautionIneligible]: GlobalColorCodes.severityYellow,
  [AusResult.ReferUnableToDetermine]: GlobalColorCodes.severityYellow,
  [AusResult.ReferWithCautionUnableToDetermine]: GlobalColorCodes.severityYellow,
};

export enum AusSystem {
  NotAssigned = 0,
  DU = 1,
  LP = 2,
  DU_EA = 3,
  GUS = 4,
  Other = 5,
  NotApplicable = 6,
  InternalProprietarySystem = 7,
}

export enum AppraisalWaiverStatus {
  Ineligible = 0,
  Eligible = 1,
}

export const AppraisalWaiverStatusColorCode = {
  [AppraisalWaiverStatus.Eligible]: GlobalColorCodes.severityGreen,
  [AppraisalWaiverStatus.Ineligible]: GlobalColorCodes.severityError,
};

export class OrderLogModel {
  ausResultOther?: string;
  ausRunId?: number;
  ausSystemOther?: string;
  embeddedDocID: number;
  duResult?: AusResult;
  lpaResult?: LpaResult;
  referenceNumber: number;
  responseTime?: string;
  system?: AusSystem;
  appraisalWaiverStatus?: AppraisalWaiverStatus;
}

export const AusResultStatusIcon: { [key: number]: string } = {
  [AusResult.NotAssigned]: `${LoanItemStatus.NotComplete} ${LoanItemStatusIconType.EmptyCircle}`,
  [AusResult.ApproveEligible]: `${LoanItemStatus.Complete} ${LoanItemStatusIconType.Circle}`,
  [AusResult.ApproveIneligible]: `${LoanItemStatus.Warning} ${LoanItemStatusIconType.Diamond}`,
  [AusResult.ReferEligible]: `${LoanItemStatus.Warning} ${LoanItemStatusIconType.Diamond}`,
  [AusResult.ReferIneligible]: `${LoanItemStatus.Error} ${LoanItemStatusIconType.Square}`,
  [AusResult.ReferWithCaution]: `${LoanItemStatus.Error} ${LoanItemStatusIconType.Square}`,
  [AusResult.OutOfScope]: `${LoanItemStatus.Error} ${LoanItemStatusIconType.Square}`,
  [AusResult.Error]: `${LoanItemStatus.Error} ${LoanItemStatusIconType.Square}`,
  [AusResult.Accept]: `${LoanItemStatus.Complete} ${LoanItemStatusIconType.Circle}`,
  [AusResult.Caution]: `${LoanItemStatus.Warning} ${LoanItemStatusIconType.Diamond}`,
  [AusResult.Ineligible]: `${LoanItemStatus.Error} ${LoanItemStatusIconType.Square}`,
  [AusResult.Incomplete]: `${LoanItemStatus.NotComplete} ${LoanItemStatusIconType.EmptyCircle}`,
  [AusResult.Invalid]: `${LoanItemStatus.Error} ${LoanItemStatusIconType.Square}`,
  [AusResult.Refer]: `${LoanItemStatus.Warning} ${LoanItemStatusIconType.Diamond}`,
  [AusResult.Eligible]: `${LoanItemStatus.Complete} ${LoanItemStatusIconType.Circle}`,
  [AusResult.UnableToDetermineOrUnknown]: `${LoanItemStatus.NotComplete} ${LoanItemStatusIconType.EmptyCircle}`,
  [AusResult.Other]: `${LoanItemStatus.NotComplete} ${LoanItemStatusIconType.EmptyCircle}`,
  [AusResult.NotApplicable]: `${LoanItemStatus.NotRequired} ${LoanItemStatusIconType.EmptyCircle}`,
  [AusResult.AcceptEligible]: `${LoanItemStatus.Complete} ${LoanItemStatusIconType.Circle}`,
  [AusResult.AcceptIneligible]: `${LoanItemStatus.Error} ${LoanItemStatusIconType.Square}`,
  [AusResult.AcceptUnableToDetermine]: `${LoanItemStatus.NotComplete} ${LoanItemStatusIconType.EmptyCircle}`,
  [AusResult.ReferWithCautionEligible]: `${LoanItemStatus.Warning} ${LoanItemStatusIconType.Diamond}`,
  [AusResult.ReferWithCautionIneligible]: `${LoanItemStatus.Error} ${LoanItemStatusIconType.Square}`,
  [AusResult.ReferUnableToDetermine]: `${LoanItemStatus.NotComplete} ${LoanItemStatusIconType.EmptyCircle}`,
  [AusResult.ReferWithCautionUnableToDetermine]: `${LoanItemStatus.NotComplete} ${LoanItemStatusIconType.EmptyCircle}`,
};

export enum AusVerificationServicesTypes {
  Asset = 0,
  Income = 1,
  TaxTranscript = 110,
}

export enum AusAssetVendorTypes {
  Formfree = 1,
  Plaid = 18,
  FF = 100,
  PLAD = 105,
}

export enum AusIncomeVendorTypes {
  LoanBeam = 104,
  Other = 9999,
  Experian = 35,
  EXPN = 111,
}

export enum AusVerificationServicesVendorTypes {
  NotAssigned = 0,
  Formfree = 1,
  Placeholder = 2,
  DataVerifySSA89 = 3,
  DataVerify = 4,
  CoreLogic = 5,
  AdvancedData = 6,
  Avantus = 7,
  BankVOD = 8,
  Blend = 9,
  Chronos = 10,
  Partners = 11,
  Finicity = 12,
  FinLocker = 13,
  FirstAmerican = 14,
  Informative = 15,
  MeridianLink = 16,
  NCS = 17,
  Plaid = 18,
  PointServ = 19,
  PrivateEyes = 20,
  QuestSoft = 21,
  SharperLending = 22,
  Universal = 23,
  VeriTax = 24,
  BlendLabs = 25,
  EWS = 26,
  FannieMaeQA = 27,
  Sharper = 28,
  Yodlee = 29,
  CreditPlus = 30,
  AdvantageCredit = 31,
  BlendIncome = 32,
  Covius = 33,
  Truework = 34,
  Experian = 35,
  Argyle = 36,
  TruvFannie = 37,
  Halcyon = 38,
  FF = 100,
  BLND = 101,
  FNCY = 102,
  EFX = 103,
  LoanBeam = 104,
  PLAD = 105,
  YODL = 106,
  PSRV = 107,
  CRLC = 108,
  LCFT = 109,
  BLNI = 110,
  EXPN = 111,
  HLCN = 112,
  ACIR = 113,
  TRUV = 114,
  Other = 9999,
}

export const processingPointList: IdValue<number, string>[] = [
  new IdValue(1, 'Application'),
  new IdValue(2, 'Final Disposition'),
  new IdValue(3, 'Post Closing Quality Control'),
  new IdValue(4, 'Prequalification'),
  new IdValue(5, 'Underwriting'),
  new IdValue(6, 'Other'),
];
